import React, { useState } from 'react';
import styled from 'styled-components';
import { InputBase } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const SearchPart = props => {
  const [searchValue, setSearchValue] = useState('');

  const handleKeyUp = e => {
    e.preventDefault();
    setSearchValue(e.target.value);
  };

  return (
    <Search>
      <Input placeholder={props.placeholder} onKeyUp={handleKeyUp} />
      <SIcon onClick={() => props.onClick(searchValue)}>
        <SearchIcon />
      </SIcon>
    </Search>
  );
};

export default SearchPart;

const Input = styled(InputBase)`
  && {
    padding-left: 2em;

    @media (max-width: 960px) {
      padding-left: 0;
    }
  }
`;

const Search = styled.div`
  display: flex;
  background-color: #f3f5f9;
  height: 40px;
  flex-shrink: 2;
  &:hover {
    background: #cfd0d3;
  }

  @media (max-width: 600px) {
    margin-left: 1em;
  }
`;

const SIcon = styled.div`
  width: 3em;
  display: flex;
  background-color: #697683;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
`;
